var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.3 7.91998V13.07C19.3 16.15 17.54 17.47 14.9 17.47H6.10995C5.65995 17.47 5.22996 17.43 4.82996 17.34C4.57996 17.3 4.33996 17.23 4.11996 17.15C2.61996 16.59 1.70996 15.29 1.70996 13.07V7.91998C1.70996 4.83998 3.46995 3.52002 6.10995 3.52002H14.9C17.14 3.52002 18.75 4.47001 19.18 6.64001C19.25 7.04001 19.3 7.44998 19.3 7.91998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 10.92V16.07C22.3 19.15 20.54 20.47 17.9 20.47H9.10995C8.36995 20.47 7.69996 20.37 7.11996 20.15C5.92996 19.71 5.11996 18.8 4.82996 17.34C5.22996 17.43 5.65995 17.47 6.10995 17.47H14.9C17.54 17.47 19.3 16.15 19.3 13.07V7.91998C19.3 7.44998 19.26 7.03001 19.18 6.64001C21.08 7.04001 22.3 8.37998 22.3 10.92Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.14C11.958 13.14 13.14 11.958 13.14 10.5C13.14 9.04197 11.958 7.85999 10.5 7.85999C9.04197 7.85999 7.85999 9.04197 7.85999 10.5C7.85999 11.958 9.04197 13.14 10.5 13.14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78003 8.25C4.37003 8.25 4.03003 8.59 4.03003 9V12C4.03003 12.41 4.37003 12.75 4.78003 12.75C5.19003 12.75 5.53003 12.41 5.53003 12V9C5.53003 8.59 5.20003 8.25 4.78003 8.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.21 8.25C15.8 8.25 15.46 8.59 15.46 9V12C15.46 12.41 15.8 12.75 16.21 12.75C16.62 12.75 16.96 12.41 16.96 12V9C16.96 8.59 16.63 8.25 16.21 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.739c06c53aa9c3826d6395c00974db3c.svg";
export { ForwardRef as ReactComponent };